export default __webpack_public_path__ + "static/media/espiritual2.c7204957.jpg";